// extracted by mini-css-extract-plugin
export default {"container":"card-title_container__2Cs4y"};